<template>
	<div class="qingwu">
		<div class="admin_main_block">
			<div class="admin_main_block_top">
				<div class="admin_main_block_left">
					<div>提现审核</div>
				</div>
				<div class="admin_main_block_right">
					<div><el-button icon="el-icon-back" @click="$router.go(-1)">返回</el-button></div>
				</div>
			</div>
			<div class="admin_form_main">
				<el-form label-width="100px" ref="info" :model="info" :rules="rules">
					<el-form-item label="提现金额" prop="price">
						<el-input type="number" disabled placeholder="请输入提现金额" v-model="info.price"></el-input>
					</el-form-item>
					<el-form-item label="金币数量" prop="amount">
						<el-input type="number" disabled placeholder="请输入金币数量" v-model="info.amount"></el-input>
					</el-form-item>
					<el-form-item label="提现用户" prop="user">
						<div class="ztable">
							<!-- {{info.user}} -->
							<table>
								<tr>
									<td>用户名</td>
									<td>{{info.user.nickname}}</td>
								</tr>
								<tr>
									<td>用户头像</td>
									<td>
										<el-avatar shape="square" :size="50" :src="info.user.avatar"></el-avatar>
									</td>
								</tr>
								<tr>
									<td>用户手机号码</td>
									<td>{{info.user.phone}}</td>
								</tr>
							</table>
						</div>

					</el-form-item>
					<el-form-item label="审核状态" prop="status">
						<el-radio-group v-model="info.status">
							<el-radio :label="2">审核驳回</el-radio>
							<el-radio :label="3">审核通过</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="驳回原因" prop="audit_error" v-if="info.status==2">
						<el-input type="textarea" :rows="5" placeholder="请输入驳回原因" v-model="info.audit_error">
						</el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="submitForm('info')">提交</el-button>
						<el-button @click="resetForm('info')">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {},
		props: {},
		data() {
			return {
				edit_id: 0,
				info: {},
				rules: {
					status: [{
						required: true,
						message: "请选择审核状态",
						trigger: "blur"
					}],
					audit_error: [{
						required: true,
						message: "请输入驳回原因",
						trigger: "blur"
					}]
				}
			};
		},
		watch: {},
		computed: {},
		methods: {
			resetForm: function(e) {
				this.$refs[e].resetFields();
			},
			submitForm: function(e) {
				let _this = this;
				// 验证表单
				this.$refs[e].validate(function(res) {
					if (res) {
						//  判断是Add 或者 Edit
						let url = _this.$api.withdrawalAudit;
						// if (_this.edit_id > 0) {
						// 	url = _this.$api.withdrawalEdit + _this.edit_id;
						// }

						// Http 请求
						_this.$post(url, _this.info).then(function(res) {
							if (res.code == 200) {
								_this.$message.success("操作成功");
								_this.$router.go(-1);
							} else {
								_this.$message.error("操作失败");
							}
						});
					}
				});
			},
		},
		created() {

			// 判断是否是编辑
			if (!this.$isEmpty(this.$route.params.id)) {
				this.edit_id = this.$route.params.id;
				this.info = this.$route.params
				this.info.status = ''
			}

		},
		mounted() {}
	};
</script>
<style lang="scss" scoped>
	.ztable table {
		border-collapse: collapse;
	}

	.ztable table,
	.ztable table tr td {
		border: 1px solid #ccc;
		padding: 6px 12px;
	}
</style>